import { apiClient } from './apiClient';

const OFFLINE_QUEUE_KEY = 'ipys-offline-queue-v1';
const OFFLINE_QUEUE_EVENT = 'ipys-offline-queue-updated';

const isBrowser = () => typeof window !== 'undefined' && typeof localStorage !== 'undefined';

const readQueue = () => {
  if (!isBrowser()) return [];
  try {
    const raw = localStorage.getItem(OFFLINE_QUEUE_KEY);
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed : [];
  } catch (error) {
    return [];
  }
};

const writeQueue = (queue) => {
  if (!isBrowser()) return;
  localStorage.setItem(OFFLINE_QUEUE_KEY, JSON.stringify(queue));
  window.dispatchEvent(
    new CustomEvent(OFFLINE_QUEUE_EVENT, {
      detail: { count: queue.length },
    })
  );
};

export const getOfflineQueueCount = () => readQueue().length;

export const enqueueOfflineRequest = ({ method, url, data, headers, label }) => {
  const queue = readQueue();
  queue.push({
    id: `${Date.now()}-${Math.round(Math.random() * 100000)}`,
    method: String(method || 'post').toLowerCase(),
    url,
    data: data || null,
    headers: headers || {},
    label: label || 'Bekleyen saha kaydı',
    created_at: new Date().toISOString(),
  });
  writeQueue(queue);
  return queue.length;
};

export const processOfflineQueue = async () => {
  if (!isBrowser() || !window.navigator.onLine) {
    return { processed: 0, remaining: getOfflineQueueCount() };
  }

  const queue = readQueue();
  if (queue.length === 0) {
    return { processed: 0, remaining: 0 };
  }

  const remaining = [];
  let processed = 0;

  for (const item of queue) {
    try {
      await apiClient({
        method: item.method,
        url: item.url,
        data: item.data,
        headers: item.headers,
      });
      processed += 1;
    } catch (error) {
      if (!error.response) {
        remaining.push(item, ...queue.slice(processed + remaining.length));
        break;
      }
      remaining.push(item);
    }
  }

  writeQueue(remaining);
  return { processed, remaining: remaining.length };
};

export const subscribeOfflineQueue = (listener) => {
  if (!isBrowser()) return () => {};
  const wrapped = (event) => listener(Number(event?.detail?.count || 0));
  window.addEventListener(OFFLINE_QUEUE_EVENT, wrapped);
  return () => window.removeEventListener(OFFLINE_QUEUE_EVENT, wrapped);
};
